/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Game_Fancy_Manatee_FlipInputs */

const en_game_fancy_manatee_flip = /** @type {(inputs: Game_Fancy_Manatee_FlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Swap ${i?.from} for ${i?.to}`)
};

/**
* | output |
* | --- |
* | "Swap {from} for {to}" |
*
* @param {Game_Fancy_Manatee_FlipInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const game_fancy_manatee_flip = /** @type {((inputs: Game_Fancy_Manatee_FlipInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Fancy_Manatee_FlipInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_game_fancy_manatee_flip(inputs)
});